import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ShareCallPayload } from '../../types';

type ShareLinkState = {
    shareConferenceLinkSuccess?: boolean;
};

const initialState: ShareLinkState = {};
const shareLinkSlice = createSlice({
    name: 'shareLink',
    initialState,
    reducers: {
        setShareConferenceLinkSuccess(state, action: PayloadAction<boolean>) {
            state.shareConferenceLinkSuccess = action.payload;
        },
        resetShareLink() {
            return initialState;
        },
    },
});

export const shareCallAction = createAction<ShareCallPayload>('conference/shareLink/share');
export const shareLinkReducer = shareLinkSlice.reducer;
export const { setShareConferenceLinkSuccess, resetShareLink } = shareLinkSlice.actions;
